enum NativeName {
  English = 'English',
  Spanish = 'Español',
  French = 'Français',
  German = 'Deutsch',
  Italian = 'Italiano',
  BrazilPortuguese = 'Português (Brasil)',
  Korean = '한국어',
  SimplifiedChinese = '中文(简体)',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  SimplifiedChineseJV = '中文(简体)',
  TraditionalChinese = '中文(繁體)',
  Japanese = '日本語',
  Russian = 'Русский',
  Indonesian = 'Bahasa Indonesia',
  Polish = 'Polski',
  Vietnamese = 'Tiếng Việt',
  Turkish = 'Türkçe',
  Arabic = 'العربية',
  Thai = 'ภาษาไทย',
}

export default NativeName;
